import List, { ListProps } from '@mui/material/List';
import ListItemIcon, { ListItemIconProps } from '@mui/material/ListItemIcon';
import ListItemText, { ListItemTextProps } from '@mui/material/ListItemText';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import ListItemButton, {
  ListItemButtonProps,
  listItemButtonClasses
} from '@mui/material/ListItemButton';

export const SidebarContainer = styled('div')({
  width: '210px',
  height: '100%',
  backgroundColor: '#404040'
});

export const HeaderTypography = styled(Typography)<TypographyProps>({
  marginTop: '20px',
  marginLeft: '20px',
  height: '80px',
  fontFamily: ["'Jost'", 'sans-serif'].join(','),
  fontSize: '22px',
  color: 'white'
});

export const InventoryButtonList = styled(List)<ListProps>({});
export const ButtonList = styled(List)<ListProps>({
  marginTop: '20px'
});

export const InventoryButton = styled(ListItemButton)<ListItemButtonProps>({
  height: '55px',
  top: '4px',
  fontWeight: 'bold',
  color: '#A3A7FA',
  cursor: 'default',
  [`&.${listItemButtonClasses.root}:hover`]: {
    backgroundColor: 'transparent'
  }
});

export const SidebarIcon = styled(ListItemIcon)<ListItemIconProps>({
  marginLeft: '5px',
  minWidth: '10px',
  color: 'white',
  fill: 'white'
});

export const ListText = styled(ListItemText)<ListItemTextProps>({});

export const InventoryTypography = styled(Typography)<TypographyProps>({
  marginLeft: '10px',
  fontFamily: 'Open Sans',
  fontSize: '16px',
  color: '#A3A7FA',
  fontWeight: 'bold'
});

export const ModifiersTypography = styled(Typography)<TypographyProps>({
  marginLeft: '50px',
  fontFamily: 'Open Sans',
  fontSize: '16px',
  color: 'white'
});

export const LogoutButtonContainer = styled('div')({
  position: 'absolute',
  bottom: '40px',
  marginLeft: '37px'
});

export const InventoryButtons = styled(ListItemButton)({
  fontFamily: 'Open Sans',
  fontSize: '16px',
  color: 'white',
  fontWeight: 'bold',
  marginLeft: '-15px',
  height: '30px',
  [`&.${listItemButtonClasses.root}`]: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  '&.Mui-selected': {
    '&:hover': {
      backgroundColor: 'transparent'
    },
    backgroundColor: 'transparent',
    '& .MuiListItemText-primary': {
      '& .MuiTypography-root': {
        fontWeight: 'bold',
        color: '#A3A7FA'
      }
    },
    '& .MuiListItemIcon-root': {
      color: '#A3A7FA',
      '&:hover': {
        backgroundColor: 'transparent'
      }
    }
  }
});

export const SidebarButtons = styled(ListItemButton)<ListItemButtonProps>({
  height: '45px',
  top: '4px',
  color: 'white',
  cursor: 'default'
});

export const ButtonsTypography = styled(Typography)<TypographyProps>({
  marginLeft: '10px',
  fontFamily: 'Open Sans',
  fontSize: '16px',
  color: 'white'
});
